// Prices are stored and sent as whole cents, and entered and shown in dollars.

// A price in cents as the user reads it, such as $19.99, in the plan's currency.
export const format_cents = (price_in_cents, currency)=>{
	const amount = Number(price_in_cents) / 100;
	try {
		return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(amount);
	}
	catch (error) {
		return amount.toFixed(2) + ' ' + currency;
	}
};

// A price in cents as the dollar text a price field starts with, such as 19.99.
export const cents_to_dollar_text = (price_in_cents)=>{
	return (Number(price_in_cents) / 100).toFixed(2);
};

// The whole cents of dollar text such as 19.99 or 20, or null when the text is not a price of 0 or more with at
// most two decimals.
export const dollar_text_to_cents = (text)=>{
	const trimmed = String(text).trim();
	if(!/^\d+(\.\d{1,2})?$/.test(trimmed)){
		return null;
	}

	return Math.round(Number(trimmed) * 100);
};
